import React from 'react';
import { Shield, Mail, Lock, Bell } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto md:p-6 min-h-screen">
      <div className="bg-white rounded-lg shadow-sm p-8 mt-20 md:my-20">
        <div className="flex items-center justify-center mb-8">
          <Shield className="h-8 w-8 text-primary mr-3" />
          <h1 className="text-3xl font-bold">Privacy Policy</h1>
        </div>

        <div className="space-y-8">
          <section>
            <div className="flex items-center gap-2 mb-4">
              <Mail className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">Information We Collect</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>At our spa, we are committed to protecting your privacy and ensuring the security of your personal information. We collect the following types of information:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Personal identification information (name, email address, phone number)</li>
                <li>Contact and billing address</li>
                <li>Payment information</li>
                <li>Health and medical information relevant to our services</li>
                <li>Appointment history and preferences</li>
                <li>Training program enrollment details (for students)</li>
                <li>Product purchase history</li>
              </ul>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-4">
              <Bell className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">How We Use Your Information</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>We use your personal information for the following purposes:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>To provide and manage our spa services, including booking appointments and sending reminders</li>
                <li>To process payments and maintain billing records</li>
                <li>To communicate important updates about our services and products</li>
                <li>To personalize your experience and provide tailored recommendations</li>
                <li>To maintain student records for our training programs</li>
                <li>To improve our services based on feedback and usage patterns</li>
              </ul>
            </div>
          </section>

          <section>
            <div className="flex items-center gap-2 mb-4">
              <Lock className="h-5 w-5 text-primary" />
              <h2 className="text-2xl font-semibold">Data Protection & Security</h2>
            </div>
            <div className="text-gray-600 space-y-4">
              <p>We implement appropriate security measures to protect your personal information:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Secure storage of all personal and medical information</li>
                <li>Limited access to personal data by authorized staff only</li>
                <li>Regular security assessments and updates</li>
                <li>Compliance with Nigerian data protection regulations</li>
                <li>Encrypted payment processing</li>
              </ul>
              <p>We retain your information only for as long as necessary to provide our services and comply with legal obligations.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Your Rights</h2>
            <div className="text-gray-600 space-y-4">
              <p>You have the right to:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Access your personal information</li>
                <li>Request corrections to your data</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
            <p className="text-gray-600">
              If you have any questions about our privacy policy or how we handle your data, please contact us at [Your Contact Information].
            </p>
          </section>

          <div className="text-sm text-gray-500 mt-8">
            Last updated: [04-02-2025]
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;